import React from 'react';
import GenericCRUD from 'src/shared/genericCRUD';
import { useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useQuery } from 'react-query';
import { getData } from 'src/api/api';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import { useTranslation } from 'react-i18next';
import FormControl from '@mui/material/FormControl';
import Loader from 'src/shared/defaultLoader';

export default function DirectoryGroupsDetail() {
  const { register, handleSubmit } = useForm();
  const { t } = useTranslation();
  let { id } = useParams();
  const getQueryFn = async ({ queryKey }) => await getData('directory/group', { queryKey });

  const { data, error, isLoading, isError } = useQuery(['directory/group', { id }], getQueryFn);

  if (isLoading) {
    return <Loader />;
  }
  if (isError) {
    return <span>Error : {error.message}</span>;
  }

  return (
    <GenericCRUD objectName={'directory/group'} handleSubmit={handleSubmit} data={data}>
      <Grid item xs={12} sm={6}>
        <FormControl variant="standard" fullWidth={true}>
          <TextField
            {...register('phone_directory_group_name')}
            required
            autoComplete="off"
            id="phone_directory_group_name"
            name="phone_directory_group_name"
            label={t('NAME')}
            fullWidth
            variant="standard"
            defaultValue={data.phone_directory_group_name}
          />
        </FormControl>
      </Grid>

      <Grid item xs={12} sm={6}>
        <FormControl variant="standard" fullWidth={true}>
          <TextField
            {...register('phone_directory_group_order')}
            required
            id="phone_directory_group_order"
            name="phone_directory_group_order"
            label={t('SORT_ORDER')}
            fullWidth
            autoComplete="family-name"
            variant="standard"
            defaultValue={data.phone_directory_group_order}
          />
        </FormControl>
      </Grid>
    </GenericCRUD>
  );
}
